












































































import {Component, Emit, Vue, Watch} from "vue-property-decorator";
import FilmBox from "@/components/FilmBox.vue";
import FilmDescription from "@/components/FilmDescription.vue";
import HeadingDivider from "@/components/HeadingDivider.vue";
import PathBox from "@/components/PathBox.vue";
import Keywords from "@/components/Keywords.vue";
import Related from "@/components/Related.vue";
import HistoryMenu from "@/components/HistoryMenu.vue";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";
import {localStorageService} from "@/services/local-storage.service";
import {LocalStorageServiceConfig} from "@/interfaces/local-storage.interface";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import {DetailPageConfig} from "@/interfaces/detail-page.interface";
import ContentPage from "@/components/ContentPage.vue";

@Component({
  components: {
    HistoryMenu,
    Related,
    Keywords,
    HeadingDivider,
    FilmDescription,
    FilmBox,
    PathBox,
    ContentPage,
  }
})

export default class DetailPage extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  routePath = RouterStore.ROUTE_PATH;

  isLoading = true;
  isScrolled = false;
  iosFullscreen = false;

  detailPage: any = null;
  heroBox: any = null;
  heroVideo: any = null;
  relatedImages: any = [];
  relatedThemes: any = null;
  pathStart: any = null;
  pathEnd: any = null;
  mediaQuery: any = null;
  playerReduction: any = null;
  pathArr = [];

  contentOffset: number = 0;
  isMobile: boolean = false;
  playerSize: number = 1;
  hideControls: boolean = false;
  openFullscreenOnPlay: boolean = true;

  selectedKeyword: any = {
    timecodes: []
  };

  pageContent: DetailPageConfig.IDetailPageConfig;

  get getVideoInfo() {
    return {
      title: this.pageContent?.title,
      director: this.pageContent?.director,
      year: this.pageContent?.year,
      description: this.pageContent?.info_text ? this.pageContent?.info_text : this.pageContent?.description,
      more_info: this.pageContent?.more_info,
      copyright: this.pageContent?.copyright,
      video_start: this.pageContent?.video_start,
      loop_start: this.pageContent?.loop_start,
      loop_end: this.pageContent?.loop_end,
    }
  }

  async created() {
    this.pageContent = await this.$store.dispatch("contentPage/getPageContent", {page: RouterStore.ROUTE_NAME.DETAIL_PAGE, id: this.$route.params.id});
    this.isLoading = false;

    bus.$on('drawPaths', () => {
      if (!this.isMobile) this.drawPaths();
    });

    bus.$on(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, this.iosFullscreenChange);

    bus.$on(EventEmitter.Events.EXIT_FULLSCREEN, () => {
      setTimeout( () => {
        this.checkDraw();
      })
    });

    bus.$on(EventEmitter.Events.PLAYER_READY, () => {
      setTimeout( () => {
        this.onDocumentResize();
      }, 200);
    });

    setTimeout( () => {
      this.init();
    });

    setTimeout( () => {
      bus.$emit(EventEmitter.Events.DATA_LOADED);
    })
  }

  getLineWidth(index: number): number {
    const relatedFilm: any  = this.pageContent.relatedFilms[index];
    return relatedFilm.connectionWidth ? relatedFilm.connectionWidth : 3 - (index * 0.5) >= 1 ? 3 - (index * 0.5) : 1;
  }

  init() {
    this.detailPage = document.querySelector('.detail-page');
    this.heroBox = document.querySelector('.detail-page__hero');
    this.pathStart = document.querySelector('.detail-page__path-start');
    this.pathEnd = document.querySelector('.detail-page__path-end');
    this.relatedImages = document.querySelectorAll('.related-box__image');
    this.relatedThemes = document.querySelector('.detail-page__themes--related');
    this.playerReduction = document.querySelector('.detail-page__player-reduction');
    this.mediaQuery = window.matchMedia("(min-width: 993px)");

    localStorageService.pushHistory(
      {
        type: LocalStorageServiceConfig.HistoryItemTypes.FILM,
        title: this.pageContent.title,
        image: this.pageContent.thumbnail,
        id: this.$router.currentRoute.params.id,
      }
    );

    this.checkMedia(this.mediaQuery);
    this.mediaQuery.addListener(this.checkMedia);
    window.addEventListener('resize', this.onDocumentResize);

    if (this.$store.state.rhizome.filterByKeywordName) {
      const keyword = this.pageContent.keywords.find(item => item.keyword === this.$store.state.rhizome.filterByKeywordName);
      if (keyword) {
        this.setActiveTag(keyword);
        (this.$refs as any).keywordsComponent.$refs['keyword-' + keyword.entity_id][0].checked = true;
      }
    }
  }

  iosFullscreenChange(state) {
    this.iosFullscreen = state;
  }

  setActiveTag(item?) {
    if (item) {
      this.selectedKeyword = item;
    }
    else {
      this.selectedKeyword =  {
        timecodes: []
      }
    }
    setTimeout(() => {
      this.onDocumentResize();
    })
  }

  onDocumentResize() {
    this.contentOffset = (this.isMobile) ? document.querySelector('.film-box').clientHeight / this.playerSize + 10 : 0;
    setTimeout( () => { bus.$emit(EventEmitter.Events.DETAIL_PAGE_OFFSET_CALCULATED); });
  }

  getScrollPos() {
    let wH = window.innerHeight;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const oldIsScrolled = this.isScrolled;
    this.isScrolled = scrollTop >= 2 * (wH / 3);
    if (oldIsScrolled !== this.isScrolled) {
      bus.$emit(EventEmitter.Events.PLAYER_STICKY_CHANGE);
    }
    this.openFullscreenOnPlay = !this.isScrolled;
  };

  initSticky() {
    this.getScrollPos();
    window.addEventListener('scroll', this.getScrollPos);
  }

  destroySticky() {
    this.isScrolled = false;
    window.removeEventListener('scroll', this.getScrollPos);
  }

  drawPaths() {
    this.pathArr = [];
    this.heroVideo = document.querySelector('.player__video iframe');
    if (this.heroVideo) {
      let posVideo = {
        x: this.heroVideo.getBoundingClientRect().left + (this.heroVideo.getBoundingClientRect().width / 2),
        y: this.heroVideo.getBoundingClientRect().top + (this.heroVideo.getBoundingClientRect().height / 2),
      };

      for (let i = 0; i < this.relatedImages.length; i++) {
        let item = this.relatedImages[i];

        let itemPos= {
          x: item.getBoundingClientRect().left + (item.getBoundingClientRect().width / 2),
          y: item.getBoundingClientRect().top + (item.getBoundingClientRect().height / 2),
        };

        let pathStr = "M" +
          (posVideo.x      ) + "," + (posVideo.y) + " " +
          "C" +
          (posVideo.x) + "," + (posVideo.y + ((itemPos.y - posVideo.y) / 2)) + " " +
          (itemPos.x - ((itemPos.x - posVideo.x) / 2)) + "," + (itemPos.y) + " " +
          (itemPos.x      ) + "," + (itemPos.y);

        this.pathArr.push(pathStr);
      }
    }
  }

  checkDraw() {
    let heroBoxTopEdge = this.heroBox.getBoundingClientRect().top;
    let topEdge = this.pathStart.getBoundingClientRect().top;
    let bottomEdge = this.pathEnd.getBoundingClientRect().top;

    if (!this.isMobile && heroBoxTopEdge >= topEdge && heroBoxTopEdge <= bottomEdge) {
      this.drawPaths();
    } else {
      this.removePaths();
    }
  }

  removePaths() {
    this.pathArr = [];
  }

  initDraw() {
    this.heroBox.addEventListener('animationend', this.checkDraw);
    window.addEventListener('scroll', this.checkDraw);
    window.addEventListener('resize', this.checkDraw);
  }

  destroyDraw() {
    this.heroBox.removeEventListener('animationend', this.checkDraw);
    window.removeEventListener('scroll', this.checkDraw);
    window.removeEventListener('resize', this.checkDraw);
    this.removePaths();
  }

  toggleBottomSpace() {
    this.isScrolled ? this.addBottomSpace() : this.removeBottomSpace();
  }

  initBottomSpace() {
    this.removeBottomSpace();
    if (this.isScrolled) this.addBottomSpace();
    window.addEventListener('scroll', this.toggleBottomSpace);
  }

  destroyBottomSpace() {
    this.removeBottomSpace();
    window.removeEventListener('scroll', this.toggleBottomSpace);
  }

  addBottomSpace() {
    if (this.detailPage && this.relatedThemes) {
      let detailPageRect = this.detailPage.getBoundingClientRect();
      let relatedThemesRect = this.relatedThemes.getBoundingClientRect();
      this.heroBox.style.marginBottom = (detailPageRect.height - (relatedThemesRect.bottom + window.pageYOffset)) + 'px';
    }
  }

  removeBottomSpace() {
    this.heroBox.style.marginBottom = 0;
  }

  initMobileBottomSpace() {
    this.addBottomSpace();
    window.addEventListener('scroll', this.addBottomSpace);
  }

  destroyMobileBottomSpace() {
    window.removeEventListener('scroll', this.addBottomSpace);
  }

  checkPlayerPos() {
    let startRect = this.playerReduction.getBoundingClientRect();

    if (startRect.top < 0) {
      this.playerSize = (startRect.top + 200) / 200;
      this.playerSize = (this.playerSize > 1) ? 1 : 0.5;
      this.hideControls = true;
    }
    else {
      this.playerSize = 1;
      this.hideControls = false;
    }
  }

  initPlayerReduction() {
    this.checkPlayerPos();
    window.addEventListener('scroll', this.checkPlayerPos);
  }

  destroyPlayerReduction() {
    this.playerSize = 1;
    this.hideControls = false;
    window.removeEventListener('scroll', this.checkPlayerPos);
  }

  checkMedia(e) {
    if (e.matches) {
      this.isMobile = false;
      this.initSticky();
      this.initDraw();
      this.initBottomSpace();
      this.destroyPlayerReduction();
      this.destroyMobileBottomSpace();
    } else {
      this.isMobile = true;
      this.openFullscreenOnPlay = true;
      this.destroySticky();
      this.destroyDraw();
      this.destroyBottomSpace();
      this.initMobileBottomSpace();
      this.initPlayerReduction();
    }
  }

  async openFilmOnRhizome() {
    await this.$store.dispatch('rhizome/openFilmOnRhizome', { filmId: Number(this.$route.params.id) });
  }

  @Watch('isScrolled')
  onIsScrolledChanged() {
    bus.$emit(EventEmitter.Events.DETAIL_SCROLLED, this.isScrolled);
  }

  @Watch('playerSize')
  onPlayerSizeChanged() {
    setTimeout(this.onDocumentResize, 200)
  }

  destroyed() {
    bus.$off(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, this.iosFullscreenChange);
    window.removeEventListener('scroll', this.getScrollPos);
    window.removeEventListener('scroll', this.checkDraw);
    document.removeEventListener('animationend', this.checkDraw);
    window.removeEventListener('resize', this.checkDraw);
    window.removeEventListener('scroll', this.toggleBottomSpace);
    this.mediaQuery.removeListener(this.checkMedia);
    window.removeEventListener('scroll', this.checkPlayerPos);
    window.removeEventListener('resize', this.onDocumentResize);
    window.removeEventListener('scroll', this.addBottomSpace);
  }
}
